import { useState } from "react";
import { Reveal } from "@/components/landing/Reveal";
import { WaButton } from "./ui";

const clp = (n) => n.toLocaleString("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 });

export const Calculator = () => {
  const [raw, setRaw] = useState("");
  const sueldo = Number(raw.replace(/\D/g, "")) || 0;
  const aporte = Math.round(sueldo * 0.07);

  return (
    <section id="calculadora" data-testid="calculator-section" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <div className="grid gap-8 rounded-2xl border border-[#E3EAEF] bg-[#F4F7F9] p-6 sm:p-10 lg:grid-cols-2 lg:gap-12">
            <div>
              <h2 className="text-[28px] font-extrabold leading-tight tracking-tight text-[#0B3C5D] sm:text-4xl">Calcula tu 7% para salud</h2>
              <p className="mt-4 text-[18px] leading-relaxed text-[#4A5864]">
                Por ley, el 7% de tu sueldo imponible va a salud. Saber ese monto te ayuda a conversar sobre qué alternativas se ajustan a tu presupuesto.
              </p>
              <label className="mt-6 block">
                <span className="mb-2 block text-[17px] font-semibold text-[#1F2A33]">Tu sueldo bruto imponible mensual</span>
                <div className="relative">
                  <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[18px] font-semibold text-[#4A5864]">$</span>
                  <input inputMode="numeric" className="field !pl-9" placeholder="Ej: 1.200.000" data-testid="calc-input"
                    value={sueldo ? sueldo.toLocaleString("es-CL") : ""} onChange={(e) => setRaw(e.target.value)} />
                </div>
              </label>
            </div>
            <div className="flex flex-col justify-center rounded-2xl bg-white p-6 sm:p-8" aria-live="polite">
              <p className="text-[17px] font-semibold text-[#4A5864]">Tu 7% para salud es aprox.</p>
              <p className="mt-2 text-[44px] font-extrabold leading-none tracking-tight text-[#0B3C5D] sm:text-[56px]" data-testid="calc-result">{clp(aporte)}</p>
              <p className="mt-1 text-[16px] text-[#4A5864]">al mes</p>
              <p className="mt-5 text-[15px] leading-relaxed text-[#4A5864]">
                Cálculo referencial. Si tu sueldo supera el tope imponible legal, el 7% se calcula sobre ese tope. El precio de cada plan depende de tu situación.
              </p>
              <WaButton className="mt-6" testId="calc-whatsapp-btn" label="Conversar sobre mi caso"
                text={sueldo ? `Hola, mi 7% para salud es aprox. ${clp(aporte)} y quiero conocer alternativas de planes.` : undefined} />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
